import { IntegrationType } from '@accedo/one-plugin-sdk';
import { useMemo } from 'react';

import { useConfig } from '#/hooks/useConfig';
import { getPluginConfigs } from '#/plugins/hooks/utils';
import { FeatureConfig } from '#/service/config/features.types';
import { useBootStore } from '#/store/boot/boot.store';

export const useAllPluginConfigs = (type: IntegrationType) => {
  const { isPluginManagerReady } = useBootStore();
  const config = useConfig();

  const integrations: FeatureConfig<any>[] | undefined = useMemo(() => {
    if (!isPluginManagerReady) {
      return;
    }

    return getPluginConfigs(config, type).all;
  }, [config, isPluginManagerReady, type]);

  return integrations;
};
